<template>
    <el-form-item :class="[getClassByCopy,component.properties.sortType==='hidden' && 'hidden',component.properties.sortType==='toTop' && 'to-top', 'rc-checkbox-run']" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName"  :title="component.name" :label-width="labelParameter.width">
        <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
        <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
          <span class="fa fa-question-circle"></span>
        </el-tooltip>
        <el-checkbox-group v-model="checkList" :class="['checkbox-group-run', component.properties.sortOrientation === 'vertical' ? 'checkbox-vertical' : 'checkbox-horizontal']" :style="{'height':height}" @change="changeValue">
          <el-checkbox v-for="(option, index) in options" :key="index" :title="option.value" :label="option.value" :disabled="disabled || component.properties.readonly" :checked="false"></el-checkbox>
        </el-checkbox-group>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, dataSource, calculationMixin } from './mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
export default {
  name: 'rc-checkbox',
  mixins: [ componentMixin, inputMixin, heightMixin, dataSource, calculationMixin ],
  props: [ 'component', 'value', 'index', 'disabled', 'labelParameter' ],
  data () {
    return {
      checkList: (this.value && this.value.split(',')) || [],
      options: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        this.loadDataSourceOptions()
      } else {
        this.loadTemplateOptions()
      }
    })
  },
  methods: {
    changeValue (val) {
      //  blur 改为change。第一次需为blur，不然初始化就会校验。原因不明
      this.rules.forEach(el => {
        el.trigger = el.trigger === 'blur' && 'change'
      })
      // 处理数据绑定
      this.handleBindData(val)
      val = val.join(',')
      this.update(val)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    handleBindData (val) {
      // 开启了绑定数据源
      if (this.component.properties.dataSource.bindData.enable && this.component.properties.dataSource.bindData.dataBinding.length > 0) {
        // 防止初始化时非数组报错
        if (!Array.isArray(val)) {
          return false
        }
        this.component.properties.dataSource.bindData.dataBinding.forEach(d => {
          // todo:单选复选只有一个值且是以文本作为值的，这里也是通过文本值去比对，可能会有不准确的问题
          let os = val.map((el) => {
            let o = this.options.find(e => e.value === el)
            if (o) {
              return o[d.showColumnId]
            }
          })
          this.update({'value': val === null || val === undefined || val === '' ? '' : os.join(','), 'archiveColumnId': d.componentId})
        })
      }
    }
  },
  watch: {
    'value' () {
      if (!this.value) {
        if (this.checkList !== []) {
          this.checkList = []
        }
      } else {
        if (this.checkList !== this.value.split(',')) {
          this.checkList = this.value.split(',')
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .rc-checkbox-run{
    .el-form-item__content{
      line-height: 0;
    }
    .checkbox-group-run {
      overflow-y: auto;
      width: 100%;
      height: 100%;
      line-height: 1;
      label.el-checkbox {
        margin-left: 30px;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        padding: 7px 0 3px;
      }
      &.checkbox-horizontal{
        label.el-checkbox{
          display: inline-block;
          width: 110px;
          margin-right: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-checkbox.vue